import React, {useState} from 'react';
import { Link } from "react-router-dom";
import createLink from "../../../libs/createLink";
import Avatar from '../Avatar';
import Icon from '../Icon';
import Alert from '../Alert';
import Report from '../Report';
import Dropdown from "../Dropdown";
import ViewMore from "../ViewMore";
import {Can} from "../../../ability-context";
import Modal from "../Modal";
import DateSince from "../Date";
import SubCommentList from "./SubCommentList";
import LikeComment from "../Like/LikeComment";
import {isNoFollowProfil} from "../../../libs/helper";
import Reader from "../../../libs/lexical/Reader";

const heightLimit = 16 * 8;

const Comment = ({
        comment = {},
        currentUser = {},
        timelineCommentsTotal = 0,
        commentType = "",
        parentId = null,
        deleteComment = () =>{},
        handleReport = () =>{},
        handleSubReport = () =>{},
        setToggleSignIn = (status) =>{},
        subCommentAnswer = () =>{},
        hasSubComments = false,
        setCurrentCommentEdit = () =>{},
        deleteSubComment = () =>{},
        previewSubComment = 2
    }) =>{

    const [toggleAlertDelete, setToggleAlertDelete] = useState(false);

    function handleDelete() {
        deleteComment(comment._id);
        setToggleAlertDelete(false);
    }

    function handleIfCanAnswer(owner){
        if(currentUser && currentUser._id){
           subCommentAnswer(comment._id, owner || comment.owner);

        } else {
            setToggleSignIn(true);
        }
    }

    let relLinkProfil = isNoFollowProfil(comment.owner) ? { rel: "nofollow" } : {};

    return (
        <div className={`comment ${(!comment.isApproved && typeof (comment.isApproved) !== 'undefined') ? 'pending' : ''}`} id={`comment_${comment._id}`}>
            <div className={"row"}>
                {comment && comment.owner !== null && comment.owner._id ? (
                    <Link to={createLink("userProfile", comment.owner)} {...relLinkProfil}>
                        <Avatar avatar={comment.owner.profile.avatar} gender={comment.owner.profile.gender}/>
                    </Link>
                ) : (
                    <Avatar gender="guest"/>
                )}
                <div className="wrapper-comment">
                    <div className={"comment-with-options"}>
                        <div className="infos">
                            <div
                                className={`comment-content`}>
                                <ViewMore limit={heightLimit} kind={"comment"}>
                                    {comment.owner !== null && comment.owner._id ? (
                                        <Link className="username"
                                              to={createLink("userProfile", comment.owner)} {...relLinkProfil}>{comment.owner.username}</Link>
                                    ) : (
                                        <span
                                            className="username unknown mr-8">{comment.authorName || "*Utilisateur Supprimé*"}</span>
                                    )}

                                    <div className="comment-editor-style">
                                        <Reader text={comment.text} meta={{
                                            mention : comment.mentions
                                        }}/>
                                    </div>
                                </ViewMore>
                            </div>
                        </div>
                        {currentUser._id ? (
                            <div className="comment-options">
                                <Dropdown align="right" classNameActive={timelineCommentsTotal === 1 ? "fixe-one-comment" : ""} activableComponent={(
                                    <Icon type="horizontal-dots"/>
                                )}>
                                    <div className="dropdown-menu">
                                        <Can action={"delete"} subject={comment} modelName="Comment">
                                            <li className="menu-item trash"
                                                onClick={() => setToggleAlertDelete(true)}><Icon
                                                type="trash"/> Supprimer
                                            </li>
                                        </Can>
                                        <Can action={"update"} subject={comment} modelName="Comment">
                                            <li className="menu-item edit"
                                                onClick={() => setCurrentCommentEdit({
                                                    parentId : parentId,
                                                    commentId : comment._id,
                                                    text : comment.text,
                                                    mentions : comment.mentions,
                                                    commentType : commentType
                                                })}><Icon
                                                type="pencil-square"/> Editer
                                            </li>
                                        </Can>
                                        <Can action={"report"} subject={comment} modelName="Comment">
                                            <li className={"menu-item"}>
                                                <Report _id={comment._id}
                                                        kind={"comments"}
                                                        type={"comment"}
                                                        handleReport={(message) =>handleReport(comment._id, message)}
                                                        title="le commentaire"/>
                                            </li>
                                        </Can>
                                    </div>
                                </Dropdown>
                            </div>
                        ) : null}
                    </div>
                    <div className="wrapper-link">
                        {comment.isApproved ? (
                            <div className="btn-group">
                                {comment._id &&
                                    <LikeComment likeType={commentType}
                                                 commentId={comment._id}
                                                 isComment={true}
                                                 isLiked={comment.isLiked}
                                                 value={comment.count && comment.count.like}
                                                 parentId={parentId}/>
                                }
                                <Can action="create" subject="Comment">
                                    ·
                                    <div className="answer"
                                         onClick={() => handleIfCanAnswer()}>répondre</div>
                                </Can>
                            </div>
                        ) : <div className="waiting-mod">En attente de modération</div>}

                        <span className="comment-date">
                                ·&nbsp;
                            <DateSince
                                date={comment.createdAt}
                                format={"DD/MM/YYYY"}
                                className={"ml-4"}
                                prefix={false}
                                currentFormat={true}
                            />
                            </span>

                        <Modal toggle={toggleAlertDelete} handleClose={() => setToggleAlertDelete(false)}>
                            <Alert
                                text="Voulez vous vraiment supprimer ce commentaire ?"
                                handleClose={() => setToggleAlertDelete(false)}
                                handleDelete={handleDelete}
                            />
                        </Modal>
                    </div>
                </div>
            </div>

            {hasSubComments ?
                <SubCommentList
                    parentId={parentId}
                    commentId={comment._id}
                    currentUser={currentUser}
                    setCurrentCommentEdit={(data) =>setCurrentCommentEdit(data)}
                    hasSubComments={hasSubComments}
                    commentType={commentType}
                    subCommentAnswer={(user)=>handleIfCanAnswer(user)}
                    handleSubReport={handleSubReport}
                    setToggleSignIn={(status) => setToggleSignIn(status)}
                    deleteComment={deleteSubComment}
                    previewSubComment={previewSubComment}
                 />
                : null}
        </div>
    )
};

export default Comment;
